export default class TypingAnimation {
  constructor(elem, opts) {
    this.elm = $(elem)
    this.typeText = opts.typetext
    this.typeId = opts.typeid
    this.animationFlg = false
    this.eventBinds()
  }

  eventBinds() {
    const _this = this
    this.checkFireAnimation()
    window.addEventListener('scroll', function(){
      _this.checkFireAnimation()
    })
  }

  checkFireAnimation(){
    this.elmPos = this.elm.offset().top
    if(!this.animationFlg){
      if(window.scrollY + (window.innerHeight * 0.7) >= this.elmPos){
        this.animationFlg = true
        this.typingAnimation()
      }
    }
  }

  typingAnimation(){
    const _this = this
    this.elm.t(this.typeText, {
      delay: 0,
      speed: 10,
      speed_vary: true,
      blink: 900,
      fin: function(){
        _this.typeFinished()
      },
    })
  }

  typeFinished(){
    const fadeTargetAry = Array.from(document.querySelectorAll('[data-aftertypeid="'+this.typeId+'"]'));
    fadeTargetAry.forEach((el) => {
      el.classList.add('is-fade')
    });
  }
}